import { useCallback, useEffect, useRef, useState } from "react";
import { useMicrophone } from "../../../hooks/use-microphone";
import { useChat } from "../../../providers/chat-provider";
import { FooterInputSendButton } from "./send-button";
import { FooterInputSTTButton } from "./stt-button";
import { FooterInputTextArea } from "./textarea";
import { FooterInputVoiceVisualizer } from "./voice-visualizer";

export const FooterInput = ({ focusPreviewInput }: { focusPreviewInput?: boolean }) => {
  const { onSubmit, currentLocale, chatbotParams, isMobile, disabled } = useChat();

  const formRef = useRef<HTMLFormElement>(null);

  const [message, setMessage] = useState("");

  const {
    checkMicroPhonePermission,
    requestMicrophonePermission,
    microPhonePermission,
    SpeechRecognition,
    handleCutMicrophone,
    isListening,
    handleStartMicrophone,
  } = useMicrophone(currentLocale ?? null, setMessage);

  useEffect(() => {
    if (formRef.current) formRef.current.autocomplete = "off";
    void checkMicroPhonePermission();
  }, [checkMicroPhonePermission]);

  const handleSubmitMessage = useCallback(
    (e?: React.FormEvent<HTMLFormElement>) => {
      e?.preventDefault();
      const sanitizedMessage = message.trim();
      if (sanitizedMessage) {
        onSubmit(sanitizedMessage);
        setMessage("");
      }
    },
    [message, onSubmit]
  );

  return (
    <form
      id="footer-input-form"
      ref={formRef}
      onSubmit={handleSubmitMessage}
      className="relative z-2"
    >
      {isListening ? (
        <FooterInputVoiceVisualizer />
      ) : (
        <FooterInputTextArea
          focusPreviewInput={focusPreviewInput}
          message={message}
          setMessage={setMessage}
          handleSubmitMessage={handleSubmitMessage}
        />
      )}

      {(message.length === 0 && SpeechRecognition && chatbotParams.sttEnabled && !isMobile) ||
      isListening ? (
        <FooterInputSTTButton
          microPhonePermission={microPhonePermission}
          requestMicrophonePermission={requestMicrophonePermission}
          isListening={isListening}
          handleCutMicrophone={handleCutMicrophone}
          handleStartMicrophone={handleStartMicrophone}
        />
      ) : (
        <FooterInputSendButton disabled={message.length === 0 || disabled} />
      )}
    </form>
  );
};
